import { Box } from '@mui/material'

import { JobStatusType } from 'features/jobs/types'
import JobsPopper from 'features/jobs/ui/JobsPopper'
import useProcessingJobs from 'features/jobs/ui/useJobs/useProcessingJobs'
import useExportingJobs from 'features/jobs/ui/useJobs/useExportingJobs'
import useImportingJobs from 'features/jobs/ui/useJobs/useImportingJobs'
import { useExportJobsLifecycle, useExportJobs } from 'features/jobs/models/exportsModel'
import { isFailed, isPendingOrRunning } from 'features/jobs/models/jobs'

function HeaderJobsStatusIndicator() {
  const { processingJobsNotCleared, areAnyProcessingJobsRunning } = useProcessingJobs()
  const { exportingJobsNotCleared, areAnyExportingJobsRunning } = useExportingJobs()
  const { importingJobsNotCleared, areAnyImportingJobsPending } = useImportingJobs()
  const exportJobs = useExportJobs()

  useExportJobsLifecycle()

  const shouldShow = Boolean(
    processingJobsNotCleared.length ||
      exportingJobsNotCleared.length ||
      importingJobsNotCleared.length ||
      exportJobs.length
  )

  if (!shouldShow) {
    return null
  }

  const somethingRunning =
    areAnyProcessingJobsRunning ||
    areAnyExportingJobsRunning ||
    areAnyImportingJobsPending ||
    exportJobs.some(isPendingOrRunning)

  const somethingFailed =
    processingJobsNotCleared.some(isFailed) ||
    exportingJobsNotCleared.some(isFailed) ||
    importingJobsNotCleared.some(isFailed) ||
    exportJobs.some(isFailed)

  const jobsPopperStatus = somethingRunning
    ? JobStatusType.Running
    : somethingFailed
    ? JobStatusType.Failure
    : JobStatusType.Success

  return (
    <Box ml={1}>
      <JobsPopper lastJobStatus={jobsPopperStatus} />
    </Box>
  )
}

export default HeaderJobsStatusIndicator
